import { getEnvKey } from './config'

export const logout = (router, cookies) => {
  // Remove auth token cookie
  cookies.remove(`token${getEnvKey('COOKIE_SUFFIX')}`, '/', getEnvKey('COOKIE_DOMAIN'))

  // Get current locale from router
  const locale = router.currentRoute.params.lang || 'en'

  // Redirect to signout page
  window.location.href = `https://bookis.com/${locale}/auth/signout`
}
